import { XGrid } from '@adornis/chemistry/elements/components/x-grid.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-grid
 */
@customElement('cr-grid')
export class ChromiumGrid extends XGrid {}
